<template>
  <a-popover placement="rightTop" trigger="click">
    <template #content>
      <a-form-model>
        <!-- 包年包月分摊 -->
        <a-form-model-item class="mb-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="label d-flex align-items-center">
              <span>{{$t('bill.bill_prepaid_amortizing')}}</span>
              <help-tooltip class="ml-1" :text="$t('bill.bill_prepaid_amortizing_tips')" />
              <span class="ml-1">:</span>
            </div>
            <a-switch
              class="ml-4"
              v-model="billShared"
              @change="billSharedChange" />
          </div>
        </a-form-model-item>
        <!-- 项目费用分摊 -->
        <a-form-model-item class="mb-0" v-if="projectSharedShow">
          <div class="d-flex justify-content-between align-items-center">
            <div class="label d-flex align-items-center">
              <span>{{$t('bill.bill_project_sharing')}}</span>
              <help-tooltip class="ml-1" :text="$t('bill.bill_project_sharing_tips')" />
              <span class="ml-1">:</span>
            </div>
            <a-switch
              class="ml-4"
              v-model="projectShared"
              @change="projectSharedChange" />
          </div>
        </a-form-model-item>
        <!-- 账单类型 -->
        <a-form-model-item class="mb-0" v-if="options.length > 1">
          <div class="d-flex justify-content-between align-items-center">
            <div class="label d-flex align-items-center">
              <span>{{$t('dashboard.currency')}}</span>
              <span class="ml-1">:</span>
            </div>
            <currency class="ml-4" :storeSetDisabled="storeSetDisabled" @change="currencyChange" />
          </div>
        </a-form-model-item>
      </a-form-model>
    </template>
    <icon :type="billSetIcon" class="mr-1" style="font-size: 24px;cursor: pointer;" />
  </a-popover>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import currencyMixin from '@Bill/mixins/currency'
import { getCurrencyOptions } from '@Bill/utils'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'BillConfig',
  mixins: [currencyMixin],
  props: {
    billShared: {
      type: Boolean,
    },
    projectShared: {
      type: Boolean,
    },
    projectSharedShow: {
      type: Boolean,
    },
    storeSetDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('common', {
      currency: state => state.bill.currency,
    }),
    options () {
      return getCurrencyOptions()
    },
    billSetIcon () {
      return this.currency.includes('CNY') ? 'bill-set-cny' : 'bill-set-usd'
    },
  },
  created () {
    const params = { admin: this.$store.getters.isAdminMode, scope: this.$store.getters.scope }
    if (hasPermission('bill_conditions_list')) {
      this.fetchCurrency(params)
    }
  },
  methods: {
    ...mapActions('common', ['fetchCurrency']),
    billSharedChange (e) {
      if (!this.storeSetDisabled) {
        this.$store.commit('bill/UPDATE_BILL_SHARED', e)
      }
      this.$emit('update:billShared', e)
    },
    projectSharedChange (e) {
      if (!this.storeSetDisabled) {
        this.$store.commit('bill/UPDATE_PROJECT_SHARED', e)
      }
      this.$emit('update:projectShared', e)
    },
    currencyChange (e) {
      this.$emit('update:currency', e)
    },
  },
}
</script>

<style lang="less" scoped>
.label {
  min-width: 110px;
}
</style>
